module.exports = __webpack_public_path__ + "static/media/[Professor_Teas]2014-03-25.4007ad6c.md";